import { Divider } from "@mui/material";
import * as React from "react";

import {
  KeyboardArrowDownIcon,
  KeyboardArrowRightIcon,
} from "@/shared/foundation/icons/mui";

import styles from "./SettingsSection.module.css";

interface SettingsSectionProps extends React.PropsWithChildren {
  title: string;
  /**
   * Turns the title into a disclosure control that hides the section's contents.
   *
   * Worth it for a section holding a list that grows — a panel with several
   * entities otherwise buries the sections below it under dozens of form fields.
   */
  collapsible?: boolean;
  /** Only meaningful with `collapsible`. Defaults to expanded. */
  defaultExpanded?: boolean;
}

export const SettingsSection = ({
  children,
  title,
  collapsible = false,
  defaultExpanded = true,
}: SettingsSectionProps) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);
  const ChevronIcon = expanded ? KeyboardArrowDownIcon : KeyboardArrowRightIcon;

  return (
    <section className={styles.section}>
      <Divider className={styles.divider} component="div" role="presentation">
        {collapsible ? (
          <button
            type="button"
            className={styles.titleButton}
            aria-expanded={expanded}
            onClick={() => setExpanded((wasExpanded) => !wasExpanded)}
          >
            <ChevronIcon className={styles.chevron} fontSize="inherit" />
            <span className={styles.title}>{title}</span>
          </button>
        ) : (
          <span className={styles.title}>{title}</span>
        )}
      </Divider>
      {(!collapsible || expanded) && children}
    </section>
  );
};
